import { cn } from '@shared/utils';
import { AttachmentsType } from '@shared/api';
import AttachIcon from '@assets/images/attach.svg';

interface AttachmentsProps {
  className?: string;
  files: AttachmentsType[];
  onDownload: (files: AttachmentsType) => void;
}

export const Attachments = (props: AttachmentsProps) => {
  return (
    <ul className={cn('m-0 flex w-full flex-col gap-2.5 overflow-hidden p-0 leading-4', 'max-md:mx-auto', props.className)}>
      {props.files?.map((item, idx) => (
        <li
          key={idx}
          className='flex h-[40px] cursor-pointer flex-nowrap items-center gap-2.5 rounded-lg border border-[#78787880] bg-white px-4 max-md:leading-none'
          onClick={() => props.onDownload(item)}
        >
          <AttachIcon />
          <span className='flex-1 truncate'>{item.fileName}</span>
        </li>
      ))}
    </ul>
  );
};
